<template>
  <button :title="title"
    class="mds-button mds-button--flat pending-replacement-lineup-name"
    type="button" @click="toggle"
  >
    <svg class="mds-icon mds-button__icon  mds-button__icon--left" aria-hidden="true">
      <use :xlink:href="setTriangle()">
        <title>{{title}}</title>
      </use>
    </svg>
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    data: {},
    title: {
      type: String,
      default: 'open/close indicator',
    },
    collapsed: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    setTriangle() {
      if (this.collapsed) {
        return 'static/mds/icons/mds.svg#triangle-fill-right';
      }
      return 'static/mds/icons/mds.svg#triangle-fill-down';
    },
    toggle() {
      this.$emit('toggle', this.data);
    },
  },
};
</script>
